'use client';

import clsx from 'clsx';
import { usePathname } from 'next/navigation';
import LinkComponent from '@/src/components/ui/LinkComponent';

const links = {
    produkter: '/',
    artikler: '/articles',
    butikker: '/shops',
};

const Navigation = () => {
    const pathname = usePathname();

    return (
        <nav className="flex gap-30 items-center md:gap-20">
            {Object.entries(links).map(([name, href]) => (
                <LinkComponent
                    key={href}
                    href={href}
                    className={clsx(
                        'font-noland text-center text-xl capitalize md:text-sm border-b-4 py-10 md:pb-5',
                        pathname === href
                            ? 'border-primary'
                            : 'border-transparent',
                    )}
                >
                    {name}
                </LinkComponent>
            ))}
        </nav>
    );
};

export default Navigation;
